export default {
  button: "0px 8px 16px rgba(84, 100, 203, 0.4)",
  cards: {
    large: "0px 4px 40px rgba(101, 106, 120, 0.08)",
    medium:
      "0px 4px 32px rgba(101, 106, 120, 0.04), 0px 4px 28px rgba(101, 106, 120, 0.04), 0px 4px 20px rgba(101, 106, 120, 0.04), 0px 4px 16px rgba(101, 106, 120, 0.04)",
  },
  dropdownMenu:
    "0px 4px 28px rgba(101, 106, 120, 0.04), 0px 4px 20px rgba(101, 106, 120, 0.04), 0px 4px 16px rgba(101, 106, 120, 0.04)",
  selectMenu: "0px 4px 20px rgba(0,0,0,0.1)",
  table: {
    container: "0px 16px 40px rgba(101, 106, 120, 0.08)",
  },
  inactiveBanner: "0px 16px 40px rgba(101, 106, 120, 0.08)",
};
